import { CommonModule } from "@angular/common";
import { Component, inject, Input, OnInit } from "@angular/core";
import { LoginService } from "@dert-services";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";

@Component({
  selector: "app-desktop-connection-status",
  templateUrl: "./connection-status.component.html",
  styleUrls: ["./connection-status.component.scss"],
  imports: [CommonModule],
  standalone: true,
})
export class DesktopConnectionStatusComponent implements OnInit {
  
  loginService = inject(LoginService);

  isConnected = new BehaviorSubject<boolean>(this.loginService.loggedIn);

  ngOnInit(): void {
      this.loginService.loginChanged.subscribe(() => {
        this.isConnected.next(this.loginService.loggedIn);
      });
  }

  getStatus(): string {
    const iconClass = "con-status__status-icon--";
    return iconClass + (this.isConnected ? "online" : "offline");
  }

  
}
